import { useMutation } from "@apollo/client";
import { DELETE_PLAYER, GET_PLAYERS_BY_TEAM_ID } from "../../GraphQL/Players";
import useNotification from "../../hooks/useNotification.js";
import ConfirmDeleteDialog from "../UI/ConfirmDeleteDialog.js";

const DeletePlayerDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [deletePlayer, { loading, error }] = useMutation(DELETE_PLAYER, {
    variables: { id: props.player.id },
    refetchQueries: [GET_PLAYERS_BY_TEAM_ID],
    onCompleted: () => {
      notifySuccess("Player deleted.");
      props.setOpen(false);
    },
  });

  return (
    <ConfirmDeleteDialog
      open={props.open}
      setOpen={props.setOpen}
      entityName={props.player.name}
      onConfirm={deletePlayer}
      loading={loading}
      error={error}
      confirmTestId="saveDeletePlayerDialogButton"
      cancelTestId="closeDeletePlayerDialogButton"
    />
  );
};

export default DeletePlayerDialog;
